import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import { getRatingEmojis } from 'srcReact/helpers/utils'

function CurrrentRating({ showRating, rating, size }) {
  const { t } = useTranslation()
  const [currentEmoji, setCurrentEmoji] = useState(null)

  useEffect(() => {
    const roundValue = Math.round(rating)
    const options = getRatingEmojis(t)
    const emoji = options.find((option) => option.value === roundValue)
    setCurrentEmoji(emoji)
  }, [rating])

  return (
    <p className={`${styles.smileyWrapper} ${styles[size]}`}>
      {currentEmoji && <Icon name={currentEmoji.icon} styleModifier={styles.emojiIcon} />}

      {showRating && <span aria-label={t('rating.rating_aria', { rating: rating, highest: 5 })}>{`${rating}/5`}</span>}
    </p>
  )
}

export default CurrrentRating
